import background from "../assets/svg/background.svg";
import { Copy, ShareNetwork as ShareIcon } from "phosphor-react";
import React from "react";
import { useCopyToClipboard, useLocation } from "react-use";
import { motion } from "framer-motion";
import { socialMediaHandles } from "./Index";

const Share = () => {
  const isShareAble = React.useMemo(() => {
    if (navigator.share === undefined) {
      return false;
    } else {
      return true;
    }
  }, []);

  const { search } = useLocation();

  const query = React.useMemo(() => new URLSearchParams(search), [search]);

  const refLink = React.useState(
    window.location.hostname + "/?ref=" + query.get("ref")
  )[0];

  const [copied, copy] = useCopyToClipboard();

  const shareData = React.useState({
    text: "Join the waitlist and stream millions of songs from your favourite african artists on our platform",
    title: "Beatfro: Listening is Everything",
    url: refLink,
  })[0];

  const share = React.useCallback(() => {
    navigator.share(shareData);
  }, [shareData]);

  return (
    <div className='h-screen w-screen flex flex-col items-center justify-center'>
      <img
        src={background}
        alt='background'
        className='w-screen h-screen fixed top-0 left-0 object-cover z-0'
      />
      <div className='flex fixed h-screen inset-0 w-screen z-50 transition-all items-center justify-center ease-in-out duration-300'>
        <div className='absolute inset-0 h-screen w-screen glass-backdrop'></div>

        {/* <img
          src={require("../assets/images/beatfro-white.png")}
          alt='beatfro'
          className='w-32'
        />
        */}
        <div className='md:absolute md:top-1/2 md:left-1/2 transform md:-translate-x-1/2 md:-translate-y-1/2 md:bg-[#5C34B3]/95 rounded-md md:shadow-lg p-10 md:max-w-md'>
          <motion.div
            initial={{
              opacity: 0,
              scale: 0.4,
              translateY: "20%",
            }}
            animate={{
              opacity: 1,
              scale: 1,
              translateY: 0,
            }}
            transition={{
              duration: 0.2,
              ease: "easeInOut",
            }}
            className='w-full flex flex-col items-center space-y-6 py-6'
          >
            <motion.div className='flex flex-col items-center space-y-10'>
              <h2 className='text-5xl font-poppins font-bold text-center relative'>
                Invite Friends
                <svg
                  className='absolute top-full z-[-1] -translate-y-4'
                  width='100%'
                  height='45'
                  viewBox='0 0 539 45'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M192.123 4.80441C271.325 1.42722 350.611 -0.34353 429.9 0.0554776C445.832 0.135653 461.706 0.397532 477.569 0.659231C496.581 0.972887 515.578 1.28629 534.641 1.28629C536.033 1.28629 537.006 1.28268 537.59 1.27955C537.882 1.27799 538.077 1.27655 538.178 1.27573L538.202 1.27571L538.234 1.2755L538.247 1.2752L538.25 1.27518L538.252 1.27514L538.253 1.27513L538.254 1.27511L538.263 1.27502L538.27 1.27498L538.294 1.27508C539.829 2.68389 538.394 4.25891 538.317 4.26274L538.301 4.26308L538.297 4.26313L538.294 4.26317L538.286 4.26323L538.285 4.26324L538.283 4.26329L538.264 4.26343L538.24 4.26379C537.922 4.26748 536.168 4.28934 533.216 4.36201C496.786 5.25891 460.37 7.18075 423.961 9.30087C448.366 9.21121 472.75 9.19876 497.1 9.19876C514.471 9.19876 523.199 9.22331 524.858 9.26733C524.962 9.2701 525.06 9.27343 525.136 9.27804C525.161 9.27959 525.238 9.28413 525.322 9.29636C525.385 9.30667 525.606 9.36315 525.761 9.424C526.439 10.0157 526.38 11.6264 525.739 12.1398C525.594 12.1946 525.387 12.2467 525.327 12.2567C525.293 12.2614 525.24 12.2676 525.215 12.27C525.167 12.2744 525.119 12.2772 525.082 12.2791C525.003 12.2832 524.901 12.2868 524.785 12.2902C524.319 12.3037 523.44 12.3179 522.185 12.333C519.667 12.3632 515.588 12.3972 510.154 12.4343C488.414 12.5827 444.938 12.7805 392.77 12.9783C381.974 13.0192 370.805 13.0602 359.38 13.1007C259.944 18.7845 160.489 23.2266 60.9864 27.242C52.5846 28.0912 44.1889 28.9883 35.7998 29.9359C35.5461 29.9646 35.264 29.9983 34.9583 30.0364C41.4599 30.0739 47.9642 29.9914 54.4858 29.9087C59.6586 29.8431 64.8422 29.7773 70.044 29.7712C76.2585 29.7639 82.473 29.76 88.6873 29.7561C148.692 29.7183 208.687 29.6805 268.565 26.6083C282.969 25.8693 297.375 25.1807 311.78 24.5051C317.126 24.138 322.455 23.7877 327.759 23.4391C328.622 23.3823 329.485 23.3256 330.347 23.2689C331.8 23.1733 345.126 22.6377 353.795 22.3283C355.966 22.2508 357.853 22.1873 359.196 22.1481C359.866 22.1286 360.407 22.115 360.781 22.1089C360.965 22.1058 361.122 22.1044 361.238 22.1055C361.29 22.106 361.361 22.1072 361.43 22.1116L361.432 22.1117C361.456 22.1132 361.542 22.1187 361.644 22.1373C361.668 22.1417 361.847 22.1715 362.05 22.2681C362.178 22.3365 362.495 22.5852 362.658 22.7839C362.842 23.1515 362.873 23.9566 362.72 24.3349C362.575 24.542 362.284 24.8107 362.163 24.8883C362.088 24.9295 361.959 24.9883 361.905 25.0086C361.806 25.0445 361.724 25.0629 361.694 25.0696C361.665 25.0757 361.639 25.0808 361.615 25.0849C361.579 25.0912 361.55 25.0952 361.534 25.0974C361.502 25.1017 361.468 25.1056 361.435 25.109C361.403 25.1124 361.371 25.1155 361.341 25.1181C361.214 25.1295 361.037 25.1424 360.814 25.1571C360.364 25.1867 359.683 25.226 358.744 25.2763C356.863 25.377 353.923 25.5229 349.667 25.7244C342.02 26.0863 334.375 26.4426 326.73 26.7988C321.814 27.0278 316.899 27.2569 311.984 27.4874C276.23 29.9435 239.937 33.136 205.419 41.5621C212.472 41.0393 219.517 40.1703 226.587 39.2982C231.168 38.733 235.76 38.1666 240.372 37.6922C241.227 37.6043 241.994 38.1981 242.085 39.0186C242.177 39.8391 241.558 40.5756 240.704 40.6635C236.233 41.1234 231.717 41.6802 227.173 42.2403C217.301 43.4573 207.301 44.6902 197.367 44.9792C195.915 45.0214 194.861 45.004 194.229 44.8838C194.066 44.8527 193.82 44.7956 193.574 44.6732C193.377 44.5752 192.78 44.2325 192.664 43.4748C192.549 42.7284 193.006 42.2393 193.151 42.0987C193.339 41.9175 193.542 41.7976 193.67 41.7286C194.158 41.4642 194.938 41.2154 195.667 41.0013C196.45 40.7717 197.376 40.5264 198.27 40.2894L198.279 40.287C214.7 35.9377 231.548 32.8428 248.555 30.517C195.294 32.6774 141.962 32.7109 88.6968 32.7444C82.4795 32.7483 76.2631 32.7522 70.0478 32.7595C64.9269 32.7655 59.7855 32.8306 54.6331 32.8958C43.7752 33.0333 32.869 33.1714 22.0049 32.7583C21.691 32.7464 21.3952 32.7246 21.1433 32.683C21.02 32.6626 20.8576 32.6297 20.6892 32.5704C20.5718 32.529 20.1996 32.3929 19.9085 32.0354C19.7374 31.8252 19.5893 31.53 19.5685 31.1682C19.5482 30.8147 19.6566 30.5246 19.7723 30.3258C19.9736 29.9796 20.2616 29.7941 20.3612 29.732C20.6072 29.5785 20.8882 29.4769 21.0805 29.4129C21.728 29.1973 22.8102 28.9558 24.0594 28.714C16.5797 29.0088 9.09962 29.3018 1.61926 29.5933C0.760538 29.6267 0.0361528 28.9855 0.00130404 28.1609C-0.0335448 27.3364 0.634339 26.6409 1.49306 26.6074C21.2507 25.8376 41.0057 25.0573 60.7583 24.2602C111.267 19.1572 161.99 15.7816 212.798 13.5492C160.323 13.6825 112.384 13.7696 79.7517 13.7696C77.4008 13.7696 75.624 13.7524 74.3737 13.7194C73.7499 13.7029 73.2437 13.6822 72.8567 13.6564C72.5293 13.6346 72.1326 13.6018 71.8364 13.5197C71.764 13.4997 71.5662 13.443 71.3575 13.3125C71.2208 13.2271 70.48 12.7189 70.6583 11.7702C70.7321 11.3775 70.9449 11.1167 71.0798 10.983C71.2173 10.8467 71.3529 10.763 71.4323 10.7185C71.5898 10.6304 71.7351 10.5824 71.8068 10.5601C72.0797 10.4755 72.4468 10.4213 72.769 10.3798C73.4913 10.2869 74.6259 10.1855 76.0906 10.0765C81.9698 9.63891 93.7064 9.04054 107.758 8.39345C127.471 7.48567 151.798 6.47949 171.038 5.68368C179.242 5.34437 186.521 5.0433 192.123 4.80441ZM126.975 21.5162C180.338 17.6072 233.885 15.3341 287.472 14.0131C233.984 16.7743 180.487 19.233 126.975 21.5162ZM366.757 9.68301C353.23 9.82129 339.701 9.99875 326.171 10.2264C254.999 10.463 178.494 10.6686 121.961 10.7472C138.414 10.0241 156.3 9.28434 171.16 8.66971C179.367 8.33025 186.652 8.02897 192.261 7.78977C271.42 4.41443 350.653 2.64502 429.884 3.04374C444.605 3.11782 459.375 3.34939 474.157 3.59199C448.591 4.82872 423.039 6.35021 397.51 7.8703C388.003 8.43637 378.499 9.00224 369 9.55314C368.252 9.5965 367.504 9.63979 366.757 9.68301ZM195.199 44.3315C195.199 44.3311 195.2 44.3307 195.201 44.3303C195.191 44.3363 195.189 44.3366 195.199 44.3315ZM21.6615 29.7362C21.6615 29.7362 21.6632 29.7365 21.6664 29.7372C21.663 29.7366 21.6614 29.7363 21.6615 29.7362Z'
                    fill='#FFB800'
                  />
                </svg>
              </h2>
              <p className='text-center text-sm font-medium'>
                Invite your friends to join the waitlist and stream millions of
                songs from your favourite african artists on our platform when
                we launch
              </p>
              <div className='bg-white w-full overflow-x-hidden rounded-md p-2  text-main-200'>
                <p className='text-xs'>Here's your referal link</p>
                <span className='w-full text-sm font-medium overflow-x-hidden truncate'>
                  {refLink.slice(0, 50)}...
                </span>
              </div>
              {isShareAble ? (
                <button
                  onClick={share}
                  className='btn w-full flex items-center space-x-2 justify-center '
                >
                  <ShareIcon color='white' size={20} />
                  <span>Share Link</span>
                </button>
              ) : (
                <button
                  className='btn w-full flex items-center space-x-2 justify-center'
                  onClick={() => copy(refLink)}
                >
                  <Copy color='white' size={20} />
                  <span>
                    {copied.value === refLink ? "Copied" : "Copy Link"}
                  </span>
                </button>
              )}
            </motion.div>
          </motion.div>
          <div className='flex items-center space-x-2 justify-center mt-14'>
            {socialMediaHandles.map((handle, index) => {
              return (
                <a
                  key={index}
                  href={handle.link}
                  title={handle.name}
                  target='_blank'
                  rel='noreferrer'
                  className='bg-main-200/30 hover:bg-main-200/40 cursor-pointer rounded-md p-2'
                >
                  {<handle.icon color='white' size={20} />}
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Share;
